import { TCategorizedDataResponseSerie } from "@/components/ui/chart/types/categorized-chart-series.type";
import { ICategorizedSerieAdapter } from "@/utils/chart/adapters/types/categorized-chart-adapter.type";
import { ICommonSeriesAdapterOptions } from "@/utils/chart/adapters/types/common-adapter.type";
import { EPrefixSymbol, getValueByPrefix } from "@/utils/translation-utils";

interface IPieSeriesAdapterOpts extends ICommonSeriesAdapterOptions {
  prefixSymbol: EPrefixSymbol;
  accessibilityDescription: string;
}

export function PieSeriesAdapter<KIND extends string>(
  opts: Partial<IPieSeriesAdapterOpts> = {},
): ICategorizedSerieAdapter<KIND> {
  return {
    adapt(data: TCategorizedDataResponseSerie<KIND>): Array<Highcharts.SeriesOptionsType> {
      const items = data.value.map(
        (item) =>
          [item.name, typeof item.value === "number" ? getValueByPrefix(item.value, opts.prefixSymbol) : null] as const,
      );

      const results: Array<Highcharts.SeriesOptionsType> = [];

      results.push({
        type: "pie",
        id: data.kind,
        name: opts.name ?? data.kind,
        data: items,
        accessibility: {
          description: opts.accessibilityDescription,
        },
      });

      return results;
    },
  };
}
